// extracted by mini-css-extract-plugin
export default {"spaceAlignLeftBlock":"annotate_spaceAlignLeftBlock__+2A82","spaceAlignContainer":"annotate_spaceAlignContainer__1wAPi","spaceAlignRighBlock":"annotate_spaceAlignRighBlock__wAp+T"};